import { Box, styled } from '@mui/material';

export const HistoryContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  margin: 'auto',
  maxWidth: '900px',
});

export const HistoryItemWrapper = styled(Box)({
  position: 'relative',
  marginTop: 20,

  '& .editText': {
    fontSize: 14,
    fontWeight: 600,
    color: '#000000',
    '& span': {
      fontWeight: 800,
    },
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 36,
    left: 13,
    height: 'calc(100% - 30px)',
    width: 1,
    background: '#E0E0E0',
    zIndex: 0,
  },
});

export const HistoryCard = styled(Box)({
  position: 'relative',
  background: '#fff',
  border: '1px solid #EEEEEE',
  borderRadius: 10,
  padding: '16px',
  marginLeft: 40,
  '& .question': {
    fontSize: 13,
    fontWeight: 600,
    lineHeight: '22.4px',
    color: '#616161',
  },
  '& .stepDescription': {
    fontSize: 14,
    fontWeight: 600,
    color: '#000000',
  },
});

export const StepAnswerContainer = styled(Box)({
  display: 'flex',
  gap: 8,
  marginTop: 8,
});
export const StepAnswerItem = styled(Box)({
  background: '#F0F4F6',
  flex: 1,
  borderRadius: 10,
  padding: '16px 20px',
  maxWidth: '50%',
});

export const ArrowIcon = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  background: '#ffffff',
  borderRadius: '50%',
  alignSelf: 'center',
  margin: '0 -20px',
  zIndex: 2,
});
